import { Component } from '@angular/core';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { StoreInformationService } from '@teem/app/core/services/store-information.service';
import { Clipboard } from '@angular/cdk/clipboard';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { STORE_TYPE } from '@teem/app/core/constants/defaults';
@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent {
  isTemplate: boolean = false;
  // branches = [];
  branches = [];
  branchData : any;
  isOpen: boolean = false; 
  activeDropdownIndex: number | null = null;  
  basicInfo: any;
  storeType: string = '';
  isTemplateData: boolean = false; 
  

  constructor(
    private storeInformationService : StoreInformationService,
    private loaderService : LoaderService,
    private clipboard: Clipboard,
    private sharedDataService: SharedDataService
  ){
    this.fetchBranches()
  }
  
  ngOnInit(): void {
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
        this.storeType = data.userInfo.store_type;
      }
    })
  }

  copyToClipboard(url: string): void {
    this.clipboard.copy(url);
    Swal.fire(i18n.done, i18n.store.store_url_copied_to_clipboard, 'success');
    // navigator.clipboard.writeText(url).then(() => {
    // }).catch(err => {
    //   console.error('Failed to copy: ', err);
    // });
  }
  
  editBranch(branchId: any = null): void {
    this.loaderService.startLoading();
    this.isTemplateData = branchId ? false : true;
    this.storeInformationService.editBranchInfo(branchId).subscribe((data: any) => {
      this.branchData = data;
      this.loaderService.stopLoading();
      this.openCreateBranchModal();
    })
  }

  toggleActionDropdown(i){
    this.activeDropdownIndex === i ? this.activeDropdownIndex = null : this.activeDropdownIndex = i;
  }

  fetchBranches(){
    this.loaderService.startLoading();
    this.storeInformationService.getBranchesInfo().subscribe((data: any) => {
      this.branches = data;
      this.loaderService.stopLoading();
    },
    (error) => {
      console.error('Error fetching branches:', error);
      this.loaderService.stopLoading();
    })
  }

  deleteBranch(branch: any): void {
    Swal.fire({
      title: i18n.delete,
      text: i18n.are_you_sure,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.delete,
      cancelButtonText: i18n.cancel
    }).then(result => {
      if(result.isConfirmed){
        this.loaderService.startLoading();
        this.storeInformationService.deleteBranch(branch.id).subscribe((data: any) => {
          this.loaderService.stopLoading();
          this.fetchBranches();
        })
      }
    });
  }

  openCreateBranchModal(): void {
    this.isOpen = true;
  }

  closeCreateBranchModal(): void {
    this.isOpen = false;
    this.branchData = '';
    this.fetchBranches();
  }

  showTemplate(): void {
    this.isTemplate = true;
  }

  hideTemplate(): void {
    this.isTemplate = false;
  }

  toggleBranchStatus(branch:any):void{
    this.loaderService.startLoading();
    this.storeInformationService.updateBranchStatus(branch.id,branch.storeFrontShow).subscribe((data: any) => {
      this.loaderService.stopLoading();
    })
  }

  fetchFoodicsBranches():void{
    this.loaderService.startLoading();
    this.storeInformationService.updateFoodicsBranch().subscribe(() => {
      this.loaderService.stopLoading();
      this.fetchBranches();
    },
    (error) => {
      console.error('Error fetching branches:', error);
      this.loaderService.stopLoading();
    })
  }

  goto(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  businessTypeChange(_businessStatus: String) {
    this.basicInfo.store_type = (STORE_TYPE.SERVICE == _businessStatus) ? STORE_TYPE.SERVICE : STORE_TYPE.PRODUCT;
    this.storeType = (STORE_TYPE.SERVICE == _businessStatus) ? STORE_TYPE.SERVICE : STORE_TYPE.PRODUCT;
    (window as any).userInfo.store_type = this.storeType;
  }
}
